import React, { useState, useEffect } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from './secondary-banners.module.css';

type SecondaryBannersProps = {
  disableBackground?: boolean;
};

const banners = [
  {
    id: 'banner-1',
    image: `${process.env.PUBLIC_URL}/images/banner/secondary-banner-1.png`,
    url: 'https://500anos.es.gov.br/#/login/40224',
    alt: 'Plano de Desenvolvimento',
  },
  {
    id: 'banner-2',
    image: `${process.env.PUBLIC_URL}/images/banner/secondary-banner-2.png`,
    url: 'https://universidades.es.gov.br/',
    alt: 'Outro Banner',
  },
];

export const SecondaryBanners: React.FC<SecondaryBannersProps> = ({
  disableBackground = false,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % banners.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(goToNext, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={styles.secondaryBanners}
      style={disableBackground ? { backgroundColor: 'transparent' } : undefined}
    >
      <div className={styles.container}>
        {banners.map((banner, index) => {
          if (index !== currentIndex) return null;
          return (
            <div key={banner.id} className={styles.slide}>
              <img
                src={banner.image}
                alt={banner.alt}
                className={styles.bannerImage}
                onClick={() => window.open(banner.url, '_blank')}
                style={{ cursor: 'pointer' }}
              />
            </div>
          );
        })}
        <button
          className={`${styles.arrow} ${styles.leftArrow}`}
          onClick={goToPrev}
        >
          <LeftOutlined />
        </button>
        <button
          className={`${styles.arrow} ${styles.rightArrow}`}
          onClick={goToNext}
        >
          <RightOutlined />
        </button>
        <div className={styles.dots}>
          {banners.map((_, index) => (
            <div
              key={index}
              className={`${styles.dot} ${
                index === currentIndex ? styles.active : ''
              }`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
